import React, { useState, useEffect } from "react";
import { 
    Card, Row, Col, Badge, Spinner, Alert, Button, Nav, Tab
} from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import Footer from "../layouts/Footer";
import Header from "../layouts/Header";
import StockCritique from "./StockCritique";
import RuptureStock from "./RuptureStock";
import Surstock from "./Surstock";

export default function AlertesStock() {
    const navigate = useNavigate();
    const [stats, setStats] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [activeTab, setActiveTab] = useState('critique');

    useEffect(() => {
        fetchStats();
    }, []);

    const fetchStats = async () => {
        try {
            setLoading(true);
            const token = localStorage.getItem("token");
            const response = await fetch(
                'https://sawd.julesferry-ga.com/api/stock_alertes.php?action=stats',
                { headers: { 'Authorization': `Bearer ${token}` } }
            );
            
            if (!response.ok) throw new Error("Erreur chargement");
            
            const result = await response.json();
            setStats(result.data);
        } catch (err) {
            setError(err.message);
        } finally {
            setLoading(false);
        }
    };

    if (loading) {
        return (
            <>
                <Header />
                <div className="main main-app p-3 p-lg-4">
                    <div className="d-flex justify-content-center align-items-center" style={{ minHeight: '60vh' }}>
                        <Spinner animation="border" variant="primary" />
                    </div>
                </div>
            </>
        );
    }

    if (error) {
        return (
            <>
                <Header />
                <div className="main main-app p-3 p-lg-4">
                    <Alert variant="danger">{error}</Alert>
                </div>
            </>
        );
    }

    return (
        <>
            <Header />
            <div className="main main-app p-3 p-lg-4">
                <div className="container-fluid">
                    {/* En-tête moderne */}
                    <Row className="mb-4 fade-in">
                        <Col md={12}>
                            <div className="d-flex justify-content-between align-items-center header-section">
                                <div className="d-flex align-items-center gap-3">
                                    <div 
                                        className="page-icon-wrapper d-flex align-items-center justify-content-center" 
                                        style={{ 
                                            width: '70px', 
                                            height: '70px', 
                                            borderRadius: '20px',
                                            background: 'linear-gradient(135deg, rgba(245, 158, 11, 0.15), rgba(217, 119, 6, 0.15))',
                                            boxShadow: '0 10px 20px rgba(245, 158, 11, 0.15)',
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            flexShrink: 0
                                        }}
                                    >
                                        <i className="ri-alert-line text-warning" style={{ fontSize: '36px', lineHeight: 1 }}></i>
                                    </div>
                                    <div>
                                        <h1 className="page-title mb-1" style={{ fontSize: '2rem', fontWeight: 700, color: '#1e293b' }}>
                                            Alertes stock
                                        </h1>
                                        <p className="page-subtitle mb-0" style={{ fontSize: '1rem', color: '#64748b' }}>
                                            Surveillance des niveaux de stock
                                        </p>
                                    </div>
                                </div>
                                <Button variant="outline-secondary" onClick={() => navigate('/stock/etat/instantane')}>
                                    <i className="ri-arrow-left-line me-2"></i>Retour
                                </Button>
                            </div>
                        </Col>
                    </Row>

                    {/* Cartes de résumé des alertes */}
                    {stats && (
                        <Row className="g-3 mb-4 stats-row">
                            <Col md={4}>
                                <Card className="border-0 shadow-sm h-100 stat-card" style={{
                                    background: 'linear-gradient(135deg, #dc3545, #bb2d3b)',
                                    color: 'white'
                                }}>
                                    <Card.Body className="p-3">
                                        <div className="d-flex align-items-center">
                                            <div className="bg-white bg-opacity-25 rounded-circle p-3 me-3">
                                                <i className="ri-close-circle-line fs-4"></i>
                                            </div>
                                            <div>
                                                <small className="text-white-50">Rupture</small>
                                                <h3 className="mb-0 fw-bold">{stats.compteurs?.total_rupture || 0}</h3>
                                                <small className="text-white-50">produits épuisés</small>
                                            </div>
                                        </div>
                                    </Card.Body>
                                </Card>
                            </Col>
                            <Col md={4}>
                                <Card className="border-0 shadow-sm h-100 stat-card" style={{
                                    background: 'linear-gradient(135deg, #f59e0b, #d97706)',
                                    color: 'white'
                                }}>
                                    <Card.Body className="p-3">
                                        <div className="d-flex align-items-center">
                                            <div className="bg-white bg-opacity-25 rounded-circle p-3 me-3">
                                                <i className="ri-alert-line fs-4"></i>
                                            </div>
                                            <div>
                                                <small className="text-white-50">Stock critique</small>
                                                <h3 className="mb-0 fw-bold">{stats.compteurs?.total_critique || 0}</h3>
                                                <small className="text-white-50">sous seuil</small>
                                            </div>
                                        </div>
                                    </Card.Body>
                                </Card>
                            </Col>
                            <Col md={4}>
                                <Card className="border-0 shadow-sm h-100 stat-card" style={{
                                    background: 'linear-gradient(135deg, #0dcaf0, #0b9cbe)',
                                    color: 'white'
                                }}>
                                    <Card.Body className="p-3">
                                        <div className="d-flex align-items-center">
                                            <div className="bg-white bg-opacity-25 rounded-circle p-3 me-3">
                                                <i className="ri-arrow-up-line fs-4"></i>
                                            </div>
                                            <div>
                                                <small className="text-white-50">Surstock</small>
                                                <h3 className="mb-0 fw-bold">{stats.compteurs?.total_surstock || 0}</h3>
                                                <small className="text-white-50">au-dessus max</small>
                                            </div>
                                        </div>
                                    </Card.Body>
                                </Card>
                            </Col>
                        </Row>
                    )}

                    {/* Onglets */}
                    <Card className="border-0 shadow-sm">
                        <Card.Header className="bg-white border-bottom">
                            <Nav variant="tabs" activeKey={activeTab} onSelect={(k) => setActiveTab(k)}>
                                <Nav.Item>
                                    <Nav.Link eventKey="critique">
                                        <Badge bg="warning" className="me-2">{stats?.compteurs?.total_critique || 0}</Badge>
                                        Stock critique
                                    </Nav.Link>
                                </Nav.Item>
                                <Nav.Item>
                                    <Nav.Link eventKey="rupture">
                                        <Badge bg="danger" className="me-2">{stats?.compteurs?.total_rupture || 0}</Badge>
                                        Rupture
                                    </Nav.Link>
                                </Nav.Item>
                                <Nav.Item>
                                    <Nav.Link eventKey="surstock">
                                        <Badge bg="info" className="me-2">{stats?.compteurs?.total_surstock || 0}</Badge>
                                        Surstock
                                    </Nav.Link>
                                </Nav.Item>
                            </Nav>
                        </Card.Header>
                        <Card.Body>
                            <Tab.Content>
                                <Tab.Pane active={activeTab === 'critique'}>
                                    <StockCritique />
                                </Tab.Pane>
                                <Tab.Pane active={activeTab === 'rupture'}>
                                    <RuptureStock />
                                </Tab.Pane>
                                <Tab.Pane active={activeTab === 'surstock'}>
                                    <Surstock />
                                </Tab.Pane>
                            </Tab.Content>
                        </Card.Body>
                    </Card>
                </div>

                <style>{`
                    .fade-in {
                        animation: fadeIn 0.5s ease;
                    }

                    @keyframes fadeIn {
                        from { opacity: 0; transform: translateY(10px); }
                        to { opacity: 1; transform: translateY(0); }
                    }

                    .stats-row .stat-card {
                        transition: all 0.3s ease;
                        border-radius: 16px;
                        overflow: hidden;
                    }

                    .stats-row .stat-card:hover {
                        transform: translateY(-5px);
                        box-shadow: 0 20px 25px -5px rgba(0,0,0,0.2) !important;
                    }

                    .nav-tabs .nav-link {
                        color: #64748b;
                        border: none;
                        padding: 0.75rem 1.5rem;
                        font-weight: 500;
                        display: flex;
                        align-items: center;
                    }

                    .nav-tabs .nav-link.active {
                        color: #4361ee;
                        background: none;
                        border-bottom: 2px solid #4361ee;
                    }

                    .nav-tabs .nav-link:hover {
                        color: #4361ee;
                        background: rgba(67, 97, 238, 0.05);
                    }
                `}</style>

                <Footer />
            </div>
        </>
    );
}